// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymentOptions_payment_container__tD96F {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 30px;
  padding: 50px 0;
}
.paymentOptions_payment_container__tD96F div {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.paymentOptions_payment_container__tD96F h2 {
  font-size: 20px;
  font-weight: 600;
}
.paymentOptions_payment_container__tD96F h2 span {
  font-size: 14px;
  font-weight: 400;
  color: var(--secondary-color);
}
.paymentOptions_payment_container__tD96F .paymentOptions_payment_button__i\\+0zQ {
  max-width: 300px;
  display: flex;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  padding: 15px 20px;
  border: none;
  background-color: var(--green-light);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}
.paymentOptions_payment_container__tD96F .paymentOptions_payment_button__i\\+0zQ img {
  width: 30px;
}
.paymentOptions_payment_container__tD96F .paymentOptions_payment_button__i\\+0zQ:hover {
  background-color: var(--primary-color);
  color: white;
  transition: all 0.3s;
}
.paymentOptions_payment_container__tD96F .paymentOptions_disabled__QMzoq {
  background-color: #f0f0f0;
  color: #b3b3b3;
  cursor: not-allowed;
}
.paymentOptions_payment_container__tD96F .paymentOptions_disabled__QMzoq:hover {
  background-color: #f0f0f0;
  color: #b3b3b3;
}
@media (max-width: 768px) {
  .paymentOptions_payment_container__tD96F {
    flex-direction: column;
    gap: 30px;
  }
}

.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs {
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-width: 300px;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs button {
  padding: 5px 10px;
  height: 40px;
  border: none;
  background-color: var(--green-light);
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs button:hover {
  background-color: var(--primary-color);
  color: white;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs button:disabled {
  background-color: #f0f0f0;
  color: #b3b3b3;
  cursor: not-allowed;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs button img {
  width: 24px;
  height: 24px;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_search_wrapper__Pdqjs input {
  width: 100%;
  padding: 10px;
  height: 40px;
  border: none;
  font-size: 16px;
  font-weight: 400;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_voucher_payment_button__Rs--i {
  margin: 0 auto;
}
.paymentOptions_voucher_payment_wrapper__hV2\\+P .paymentOptions_voucher_payment_button__Rs--i:disabled {
  background-color: #f0f0f0;
  color: #b3b3b3;
  border-color: #b3b3b3;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Payment/PaymentOptions/paymentOptions.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AACN;AAGE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AADJ;AAEI;EACE,WAAA;AAAN;AAIE;EACE,sCAAA;EACA,YAAA;EAEA,oBAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAJJ;AAMI;EACE,yBAAA;EACA,cAAA;AAJN;AAQE;EA7DF;IA8DI,sBAAA;IACA,SAAA;EALF;AACF;;AASE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AANJ;AAQI;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AANN;AAQM;EACE,sCAAA;EACA,YAAA;AANR;AASM;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAPR;AAUM;EACE,WAAA;EACA,YAAA;AARR;AAYI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAVN;AAcE;EACE,cAAA;AAZJ;AAcI;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAZN","sourcesContent":[".payment_container {\n  display: flex;\n  justify-content: center;\n  gap: 50px;\n  margin-top: 30px;\n  padding: 50px 0;\n\n  div {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  h2 {\n    font-size: 20px;\n    font-weight: 600;\n\n    span {\n      font-size: 14px;\n      font-weight: 400;\n      color: var(--secondary-color);\n    }\n  }\n\n  .payment_button {\n    max-width: 300px;\n    display: flex;\n    gap: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    padding: 15px 20px;\n    border: none;\n    background-color: var(--green-light);\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.3s;\n    img {\n      width: 30px;\n    }\n  }\n\n  .payment_button:hover {\n    background-color: var(--primary-color);\n    color: white;\n\n    transition: all 0.3s;\n  }\n\n  .disabled {\n    background-color: #f0f0f0;\n    color: #b3b3b3;\n    cursor: not-allowed;\n\n    &:hover {\n      background-color: #f0f0f0;\n      color: #b3b3b3;\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 30px;\n  }\n}\n\n.voucher_payment_wrapper {\n  .search_wrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    max-width: 300px;\n\n    button {\n      padding: 5px 10px;\n      height: 40px;\n      border: none;\n      background-color: var(--green-light);\n      border-radius: 5px;\n      cursor: pointer;\n      transition: all 0.3s;\n\n      &:hover {\n        background-color: var(--primary-color);\n        color: white;\n      }\n\n      &:disabled {\n        background-color: #f0f0f0;\n        color: #b3b3b3;\n        cursor: not-allowed;\n      }\n\n      img {\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    input {\n      width: 100%;\n      padding: 10px;\n      height: 40px;\n      border: none;\n      font-size: 16px;\n      font-weight: 400;\n    }\n  }\n\n  .voucher_payment_button {\n    margin: 0 auto;\n\n    &:disabled {\n      background-color: #f0f0f0;\n      color: #b3b3b3;\n      border-color: #b3b3b3;\n      cursor: not-allowed;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"payment_container": `paymentOptions_payment_container__tD96F`,
	"payment_button": `paymentOptions_payment_button__i+0zQ`,
	"disabled": `paymentOptions_disabled__QMzoq`,
	"voucher_payment_wrapper": `paymentOptions_voucher_payment_wrapper__hV2+P`,
	"search_wrapper": `paymentOptions_search_wrapper__Pdqjs`,
	"voucher_payment_button": `paymentOptions_voucher_payment_button__Rs--i`
};
export default ___CSS_LOADER_EXPORT___;
